import { lazy } from 'react';

/** Загружает страницу проверочных уведомлений */
export const PushTestsPageAsync = lazy(() => import('./PushTestsPage'));
